import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';
import I18n from 'utils/I18n';

import { ADD_PLUS_LENGTH, ADD_PLUS_ICON_WIDTH } from './constants';

const AddButton = ({ onClick }) => (
  <button className="AddButton" onClick={onClick}>
    <span className="AddButton__text">{I18n.localize('cart.upsells.add')}</span>
    <div className="AddButton__plus" />
    <style jsx>
      {`
        .AddButton {
          border: 0;
          background: none;
          font-size: ${Theme.get('font-size-small-px')};
          font-weight: ${Theme.get('font-weight-semi-bold')};
          text-transform: uppercase;
          padding: ${Theme.get('spacing') * 2}px;
          margin: -${Theme.get('spacing') * 2}px -${Theme.get('spacing') * 2}px -${Theme.get(
              'spacing'
            ) * 2}px ${Theme.get('spacing') * 2}px;
          cursor: pointer;
          flex-shrink: 0;
        }

        .AddButton:focus {
          outline: none;
        }

        .AddButton.focused {
          outline: 2px solid ${Theme.get('colors-black')};
        }

        .AddButton:hover .AddButton__plus:before {
          transform: rotate(90deg);
        }

        .AddButton:hover .AddButton__plus:after {
          transform: rotate(180deg);
        }

        .AddButton__text {
          font-size: ${Theme.get('font-size-small-px')};
          font-weight: ${Theme.get('font-weight-semi-bold')};
          margin-right: ${Theme.get('spacing-px')};
        }

        .AddButton__plus {
          position: relative;
          display: inline-block;
          width: ${ADD_PLUS_LENGTH}px;
          height: ${ADD_PLUS_LENGTH}px;
          margin-top: -5px;
        }

        .AddButton__plus:before,
        .AddButton__plus:after {
          position: absolute;
          content: '';
          display: block;
          top: 0;
          right: ${ADD_PLUS_LENGTH / 2}px;
          background-color: ${Theme.get('colors-black')};
          width: ${ADD_PLUS_ICON_WIDTH}px;
          height: ${ADD_PLUS_LENGTH}px;
          transition:
            background-color linear ${Theme.get('transition-duration-ms')},
            transform ease-in-out ${Theme.get('transition-duration-ms')};
        }

        .AddButton__plus:after {
          transform: rotate(90deg);
        }
      `}
    </style>
  </button>
);

AddButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

AddButton.defaultProps = {};

export default AddButton;
